import { message } from "antd";
import axiosInstance from "../axiosInstance";
import { PAGE_SIZE } from "../constants";

import {
	CREATE_NOTIFICATION_REQUEST,
	CREATE_NOTIFICATION_SUCCESS,
	CREATE_NOTIFICATION_FAIL,
	RESET_DELETE_NOTIFICATION,
	FETCH_NOTIFICATIONS_REQUEST,
	FETCH_NOTIFICATIONS_SUCCESS,
	FETCH_NOTIFICATIONS_FAIL,
	UPDATE_NOTIFICATION_REQUEST,
	UPDATE_NOTIFICATION_SUCCESS,
	UPDATE_NOTIFICATION_FAIL,
	DELETE_NOTIFICATION_REQUEST,
	DELETE_NOTIFICATION_SUCCESS,
	DELETE_NOTIFICATION_FAIL,
	FETCH_NOTIFICATION_REQUEST,
	FETCH_NOTIFICATION_SUCCESS,
	FETCH_NOTIFICATION_FAIL,
	FETCH_STORES_REQUEST,
	FETCH_STORES_SUCCESS,
	FETCH_STORES_FAIL,
} from "../constants/notification";

const createNotification = (values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: CREATE_NOTIFICATION_REQUEST });
	try {
		const { data } = await axiosInstance.post("/admin/notifications", values, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});
		message.success("Created.");
		dispatch(fetchNotifications({ start: 0, count: PAGE_SIZE }));
		dispatch({
			type: CREATE_NOTIFICATION_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: CREATE_NOTIFICATION_FAIL, payload: errorMessage });
	}
};

const fetchNotifications = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: FETCH_NOTIFICATIONS_REQUEST });
	try {
		const { data } = await axiosInstance.get("/admin/notifications", {
			params,
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: FETCH_NOTIFICATIONS_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_NOTIFICATIONS_FAIL, payload: errorMessage });
	}
};

const resetDeleteNotification = () => async (dispatch) => {
	dispatch({ type: RESET_DELETE_NOTIFICATION });
};

const updateNofication = (id, values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: UPDATE_NOTIFICATION_REQUEST });
	try {
		const { data } = await axiosInstance.patch(
			`/admin/notifications/${id}`,
			values,
			{
				headers: {
					Authorization: "Bearer " + adminInfo.authToken,
				},
			},
		);

		message.success("Updated.");
		dispatch({
			type: UPDATE_NOTIFICATION_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: UPDATE_NOTIFICATION_FAIL, payload: errorMessage });
	}
};

const deleteNotification = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: DELETE_NOTIFICATION_REQUEST });
	try {
		const { data } = await axiosInstance.delete(`/admin/notifications/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		message.success("Deleted.");
		dispatch({
			type: DELETE_NOTIFICATION_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: DELETE_NOTIFICATION_FAIL, payload: errorMessage });
	}
};

const fetchNotification = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: FETCH_NOTIFICATION_REQUEST });

	try {
		const { data } = await axiosInstance.get(`/admin/notifications/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({ type: FETCH_NOTIFICATION_SUCCESS, payload: data.data });
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: FETCH_NOTIFICATION_FAIL, payload: errorMessage });
	}
};

const fetchStores = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: FETCH_STORES_REQUEST });
	try {
		const { data } = await axiosInstance.get("/admin/sfcc-stores", {
			params,
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: FETCH_STORES_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_STORES_FAIL, payload: errorMessage });
	}
};

export {
	createNotification,
	resetDeleteNotification,
	fetchNotifications,
	updateNofication,
	deleteNotification,
	fetchNotification,
	fetchStores,
};
